import { render, staticRenderFns } from "./CompanyFields.vue?vue&type=template&id=4b5c027c&scoped=true"
import script from "./CompanyFields.vue?vue&type=script&lang=js"
export * from "./CompanyFields.vue?vue&type=script&lang=js"
import style0 from "./CompanyFields.vue?vue&type=style&index=0&id=4b5c027c&prod&lange=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c027c",
  null
  
)

export default component.exports